const VERSION = '6.8.0';

export { VERSION };
